// abbreviation/abbreviation.js

import SimpleBoxEditing from './highlight-textediting';
import SimpleBoxUI from './highlight-textui';
import { Plugin } from '@ckeditor/ckeditor5-core';

export default class SimpleBox extends Plugin {
    static get requires() {
        return [ SimpleBoxEditing, SimpleBoxUI ];
    }
}
